/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_TierInputs */

const en_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Tier`)
};

const es_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel actual`)
};

const fr_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau actuel`)
};

const de_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Stufe`)
};

const ja_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のティア`)
};

const zh_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前等级`)
};

const ar_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المستوى الحالي`)
};

const id_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat Saat Ini`)
};

const it_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello Attuale`)
};

const ru_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущий уровень`)
};

const pt_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível Atual`)
};

const ko_current_tier = /** @type {(inputs: Current_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 등급`)
};

/**
* | output |
* | --- |
* | "Current Tier" |
*
* @param {Current_TierInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const current_tier = /** @type {((inputs?: Current_TierInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_TierInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_current_tier(inputs)
	if (locale === "es") return es_current_tier(inputs)
	if (locale === "fr") return fr_current_tier(inputs)
	if (locale === "de") return de_current_tier(inputs)
	if (locale === "ja") return ja_current_tier(inputs)
	if (locale === "zh") return zh_current_tier(inputs)
	if (locale === "ar") return ar_current_tier(inputs)
	if (locale === "id") return id_current_tier(inputs)
	if (locale === "it") return it_current_tier(inputs)
	if (locale === "ru") return ru_current_tier(inputs)
	if (locale === "pt") return pt_current_tier(inputs)
	return ko_current_tier(inputs)
});